<template lang="pug">
  .lesson-block__content
    p.lesson-block__title.main-block__title
      | Задание с оценкой участников

    Input.lesson-block__edit(
      v-model="contentLocal.title"
      title="Название задания"
      placeholder="Название задания"
    )

    MarkdownText.lesson-block__edit.lesson-block__markdown(
      v-model="contentLocal.description"
      title="Описание задания"
      placeholder="Описание задания"
    )

    .lesson-block__buttons
      Button.-xs-(@click="emitSave" :isLoading="isLoading") Сохранить
      ButtonCancel.-xs-.hover__link(@click="cancel") Отмена

</template>

<script>
import _ from 'lodash';
import MarkdownText from '@/components/Form/MarkdownText';

export default {
  components: { MarkdownText },
  props: ['propContentLocal', 'saveBlock', 'isLoading'],
  data: () => ({
    contentLocal: {
      numbers: {}
    }
  }),
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.propContentLocal);
    },
    getNumberIcon(key) {
      switch (key) {
        case 'money':
          return 'purse';
        case 'deals':
          return 'deal';
        case 'analytics':
          return 'analytics';
        case 'marketing':
          return 'marketing';
        case 'sales':
          return 'deal';
        case 'team':
          return 'user-group';
        default:
          return '';
      }
    },
    getNumberText(key) {
      switch (key) {
        case 'money':
          return 'Деньги';
        case 'deals':
          return 'Сделки';
        case 'analytics':
          return 'Аналитика';
        case 'marketing':
          return 'Маркетинг';
        case 'sales':
          return 'Продажи';
        case 'team':
          return 'Команда';
        default:
          return '';
      }
    },
    emitSave() {
      this.$emit('update:propContentLocal', this.contentLocal);
      this.$emit('saveBlock');
    },
    cancel() {
      this.$emit('cancel');
      this.setData();
    }
  }
};
</script>
